import coreModule from 'rhino/src/core/core.module';
import rnSession from 'rhino/src/components/session/session.module';
import * as rnProfile from './profile.service.js';

export default angular.module('rhino.components.profile', [
  coreModule,
  rnSession,
])
  .factory(rnProfile.name, rnProfile.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/profile/profile.module.js